var styles = {"switchIcon":"styles_switch-icon__E-z-v","knob":"styles_knob__e540p","on":"styles_on__in8Wp"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
